export default __webpack_public_path__ + "static/media/background.481d99d0.jpg";